import './App.css';

import React from "react";
import { connect } from 'react-redux';

import {
	HashRouter as Router,
	Switch,
	Route,
} from "react-router-dom";


import Home from './js/pages/Home';
import TargetHours from './js/pages/TargetHours';
import SchoolMatcher from './js/pages/SchoolMatcher';

const App = () => {
	return (
		<div className="App">
			<Router>
				<Switch>
					<Route path={`/targethours/:schoolRollNumberSlug`}>
						<TargetHours />
					</Route>
					<Route path={`/schoolmatcher/:targetTotalSETHoursSlug/:schoolRollNumberSlug/:options?`}>
						<SchoolMatcher />
					</Route>

					<Route path={`/`}>
						<Home />
					</Route>
				</Switch>					
			</Router>        
		</div>
	)
};

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})


export default connect(
		mapStateToProps, 
		mapDispatchToProps
)(App);
